<template>
  <CRow>
    <CCol sm="12" v-if="withCard">
      <CCard>
        <CCardHeader>
          <slot name="header">
            <CIcon name="cil-grid" />
            {{title}}
          </slot>
        </CCardHeader>
        <CCardBody v-if="!isLoading">
          <CRow v-if="enableAddButton">
            <CCol sm="12">
              <CButton @click="addForm()" size="sm" color="linkedin" name="linkedin">
                <i class="fa fa-plus-square"></i>&nbsp;
                <span>Add {{title}}</span>
              </CButton> &nbsp;
              <CButton v-if="enableGenerateAllCoverage" @click="generateAllCoverage()" size="sm" color="info" >
                <i class="fa fa-plus-square"></i>&nbsp;
                <span>Add {{title}}</span>
              </CButton>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <br />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <TableOnly
                :hover="hover"
                :striped="striped"
                :border="border"
                :small="small"
                :fixed="fixed"
                :items="items"
                :fields="fields"
                :items-per-page="10"
                :loading="isLoading"
                :enableAddButton="enableAddButton"
                :dark="dark"
                :editButton="editButton"
                :removeButton="removeButton"
                :redirectDetail="redirectDetail"
                :redirectDetail2="redirectDetail2"
                @editForm="editForm"
                @addForm="addForm"
                @removeData="removeData"
                @previewImage="previewImage"
              />
            </CCol>
          </CRow>
        </CCardBody>
         <CCardBody v-else>
           <loading></loading>
         </CCardBody>
      </CCard>
    </CCol>

    <CCol sm="12" v-if="!withCard">
      <template v-if="!isLoading">
      <CRow v-if="enableAddButton">
        <CCol sm="12">
          <CButton @click="addForm()" size="sm" color="linkedin" name="linkedin">
            <i class="fa fa-plus-square"></i>&nbsp;
            <span>Add {{title}}</span>
          </CButton>&nbsp;
          <CButton v-if="enableGenerateAllCoverage" @click="generateAllCoverage()" size="sm" color="info">
            <i class="fa fa-plus-square"></i>&nbsp;
            <span>Add {{title}}</span>
          </CButton>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <TableOnly
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :items-per-page="10"
            :loading="isLoading"
            :enableAddButton="enableAddButton"
            :dark="dark"
            :editButton="editButton"
            :removeButton="removeButton"
            :redirectDetail="redirectDetail"
            :redirectDetail2="redirectDetail2"
            @editForm="editForm"
            @addForm="addForm"
            @removeData="removeData"
            @previewImage="previewImage"
          />
        </CCol>
      </CRow>
      </template>

      <template v-else>
        <CRow>
          <CCol sm="12">
            <loading></loading>
          </CCol>
        </CRow>
      </template>
    </CCol>
  </CRow>
</template>

<script>
import loading from "@/templates/Loading";
import TableOnly from "./TableOnly";

export default {
  name: "Table",
  components: { loading, TableOnly },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default() {
        return true;
      },
    },
    striped: {
      type: Boolean,
      default() {
        return true;
      },
    },
    border: {
      type: Boolean,
      default() {
        return true;
      },
    },
    small: {
      type: Boolean,
      default() {
        return true;
      },
    },
    fixed: {
      type: Boolean,
      default() {
        return true;
      },
    },
    dark: {
      type: Boolean,
      default() {
        return false;
      },
    },
    redirectDetail: {
      type: Boolean,
      default() {
        return false;
      },
    },
    redirectDetail2: {
      type: Boolean,
      default() {
        return false;
      },
    },
    editButton: {
      type: Boolean,
      default() {
        return false;
      },
    },
    removeButton: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isLoading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    enableAddButton: {
      type: Boolean,
      default() {
        return true;
      },
    },
    enableGenerateAllCoverage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    customVariableId: {
      type: String,
      default: "id",
    },
    withCard: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  methods: {
    addForm: function () {
      this.$emit("addForm");
    },
    editForm: function (row) {
      this.$emit("editForm", row);
      //this.$emit("isEdit", true);
      this.$root.$emit("bv::show::modal", this.idModals);
    },
    removeData: function (row) {
      this.$emit("removeData", row);
    },
    previewImage: function (row) {
      this.$emit("previewImage", row);
    },
    generateAllCoverage: function() {
      this.$emit("generateAllCoverage");
    }
  },
};
</script>
